module.exports = __webpack_public_path__ + "img/email.5c410f16.png";